<p-dialog [(visible)]="displayAddEditDialog" [modal]="true" [closable]="false" [style]="{width: '90vw'}" appendTo="body">
    <ng-template pTemplate="header">
        <div style="display: flex; justify-content: space-between; width: 50%;">
            <h5 class="p-mb-0">{{ dialogHeader }}</h5>
        </div>
        <div class="p-ml-auto p-d-flex p-ai-center">
            <div *ngIf="opportunityViewDetails && crudType=='view'" class="p-mr-2">
                <strong> Created by {{ opportunityViewDetails.createdByUserName }}</strong> {{ opportunityViewDetails.createdDate }}
            </div>
            <button pButton pRipple *ngIf="editPermission && opportunityViewDetails && opportunityViewDetails?.isActive && crudType=='view'" (click)="switchToEdit()" class="p-button-text p-button-rounded" icon="pi pi-pencil"></button>
            <button pButton pRipple type="button" icon="pi pi-times" (click)="closeOpportunityDialog()" class="p-button-rounded p-dialog-header-icon p-dialog-header-close"></button>
        </div>

    </ng-template>
    <ng-container *ngIf="opportunityForm && checkedFields && crudType!='view'">
        <form [formGroup]="opportunityForm" novalidate>
            <div class="header">
                <h5>
                    {{ templateSections?.[0]?.name||'Opportunity Information'}}
                    <p-inputSwitch formControlName="isActive" class="header-switch" [disabled]="crudType=='view'" (onChange)="changeStatus($event)"></p-inputSwitch>
                </h5>
            </div>

            <div class="card">
                <div class="p-grid">
                    <div *ngIf="opportunityChannelList && crudType == 'add'" class="p-col-12 p-md-6">
                        <label>Opportunity Channel <span class="required-sign">*</span></label>
                        <p-dropdown [options]="opportunityChannelList" formControlName="pipelineId"  optionLabel="name" optionValue="id" appendTo="body" [placeholder]="'Select Opportunity Channel'" (onChange)="selectedOpportunityChannel($event.value)">
                        </p-dropdown>
                        <div *ngIf="detailsFormErrors?.pipelineId" class="p-invalid">
                            <small>{{ detailsFormErrors?.pipelineId }}</small>
                        </div>
                    </div>

                    <div *ngIf="checkedFields.sequenceNumber?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.sequenceNumber?.labelName }} <span *ngIf="checkedFields.sequenceNumber?.isRequired" class="required-sign">*</span></label>
                        <input type="text" pInputText formControlName="sequenceNumber" >

                        <div *ngIf="detailsFormErrors?.sequenceNumber" class="p-invalid">
                            <small>{{ detailsFormErrors?.sequenceNumber }}</small>
                        </div>
                    </div>

                    <div *ngIf="checkedFields.name?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.name?.labelName }} <span *ngIf="checkedFields.name?.isRequired" class="required-sign">*</span></label>
                        <input type="text" pInputText formControlName="name" [placeholder]="'Enter ' + checkedFields.name?.labelName">

                        <div *ngIf="detailsFormErrors?.name" class="p-invalid">
                            <small>{{ detailsFormErrors?.name }}</small>
                        </div>
                    </div>

                    <div *ngIf="checkedFields.accountId?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.accountId?.labelName }}</label>

                        <!-- <p-autoComplete formControlName="accountId" [suggestions]="accountList"
                            field="nameWithSequenceNumber" dataKey="id" [forceSelection]="true" [placeholder]="'Select ' + checkedFields.accountId?.labelName"
                            (completeMethod)="searchAccount($event.query)" (onSelect)="getAccountContacts($event.value)"
                            [multiple]="false" [completeOnFocus]="true" appendTo="body" [disabled]="accountSelectionDisabled">
                            <ng-template let-account pTemplate="item">
                                {{account.nameWithSequenceNumber}}
                            </ng-template>
                        </p-autoComplete> -->
                        
                        <div class="association-name">
                            <span (click)="openParentAcountDialog()" *ngIf="!opportunityForm?.get('accountId')?.value" class="hyper-link"><strong class="association-name"><i class="pi pi-plus p-mr-2"></i> Select {{ checkedFields.accountId?.labelName}}</strong></span>
                            <span (click)="!accountSelectionDisabled && openParentAcountDialog()" *ngIf="opportunityForm?.get('accountId')?.value" class="hyper-link">
                                <strong class="association-name">
                                    @if(!accountSelectionDisabled){
                                        <i class="pi pi-pencil p-mr-2"></i> 
                                    }
                                    <ng-container *ngIf="opportunityForm?.get('accountId')?.value?.sequenceNumber">
                                        {{ opportunityForm?.get('accountId').value?.sequenceNumber }} -
                                    </ng-container>
                                    {{ opportunityForm?.get('accountId').value?.businessName }}
                                </strong>
                                @if(!accountSelectionDisabled){
                                    <i (click)="removeParentAccount()" class="pi pi-times p-ml-3"></i>
                                }
                                
                            </span>
                        </div>

                        <div *ngIf="detailsFormErrors?.accountId" class="p-invalid">
                            <small>{{ detailsFormErrors?.accountId }}</small>
                        </div>
                    </div>

                    <div *ngIf="checkedFields.ownerId?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.ownerId?.labelName }} <span *ngIf="checkedFields.ownerId?.isRequired" class="required-sign">*</span></label>

                        <p-dropdown formControlName="ownerId" [options]="activeUsersList" optionValue="id" optionLabel="name" [filter]="true" [placeholder]="'Select ' + checkedFields.ownerId?.labelName" appendTo="body">
                            <ng-template let-user pTemplate="item">
                                <div class="user-item" [ngClass]="{'inactive-item': user.statusId == 2 }">
                                    <div>{{user.name}}</div>
                                </div>
                            </ng-template>
                        </p-dropdown>

                        <div *ngIf="detailsFormErrors?.ownerId" class="p-invalid">
                            <small>{{ detailsFormErrors?.ownerId }}</small>
                        </div>
                    </div>

                    <div *ngIf="checkedFields.contactName?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.contactName?.labelName }} <span *ngIf="checkedFields.contactName?.isRequired" class="required-sign">*</span></label>
                        <p-autoComplete formControlName="contactName" name="contactNames"
                            [suggestions]="contactNamesForSuggestions" field="contactName"
                            [completeOnFocus]="true"
                            (completeMethod)="searchContact($event.query)" (onSelect)="getContactsDetails($event.value)"
                            [multiple]="false" appendTo="body" [placeholder]="'Select ' + checkedFields.contactName?.labelName">
                        </p-autoComplete>

                        <div *ngIf="detailsFormErrors?.contactName" class="p-invalid">
                            <small>{{ detailsFormErrors?.contactName }}</small>
                        </div>
                    </div>

                    <div *ngIf="checkedFields.contactEmailAddress?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.contactEmailAddress?.labelName }} <span *ngIf="checkedFields.contactEmailAddress?.isRequired" class="required-sign">*</span></label>
                        <input formControlName="contactEmailAddress" pInputText type="text" [placeholder]="'Enter ' + checkedFields.contactEmailAddress?.labelName">

                        <div *ngIf="detailsFormErrors?.contactEmailAddress" class="p-invalid">
                            <small>{{ detailsFormErrors?.contactEmailAddress }}</small>
                        </div>
                    </div>

                    <div *ngIf="checkedFields.contactMobileNo?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.contactMobileNo?.labelName }} <span *ngIf="checkedFields.contactMobileNo?.isRequired" class="required-sign">*</span></label>
                        <input formControlName="contactMobileNo" pInputText type="text" [placeholder]="'Enter ' + checkedFields.contactMobileNo?.labelName">

                        <div *ngIf="detailsFormErrors?.contactMobileNo" class="p-invalid">
                            <small>{{ detailsFormErrors?.contactMobileNo }}</small>
                        </div>
                    </div>

                    <div *ngIf="checkedFields.ratingId?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.ratingId?.labelName }} <span *ngIf="checkedFields.ratingId?.isRequired" class="required-sign">*</span></label>
                        <p-dropdown formControlName="ratingId" [options]="opportunityRating" optionLabel="name" optionValue="id" [filter]="true" appendTo="body" [placeholder]="'Select ' + checkedFields.ratingId?.labelName">
                        </p-dropdown>

                        <div *ngIf="detailsFormErrors?.ratingId" class="p-invalid">
                            <small>{{ detailsFormErrors?.ratingId }}</small>
                        </div>
                    </div>

                    <div *ngIf="checkedFields.sourceId?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.sourceId?.labelName }} <span *ngIf="checkedFields.sourceId?.isRequired" class="required-sign">*</span></label>
                        <p-dropdown formControlName="sourceId" [options]="opportunitySources" optionLabel="name" optionValue="id" [filter]="true" appendTo="body" [placeholder]="'Select ' + checkedFields.sourceId?.labelName">
                        </p-dropdown>

                        <div *ngIf="detailsFormErrors?.sourceId" class="p-invalid">
                            <small>{{ detailsFormErrors?.sourceId }}</small>
                        </div>
                    </div>

                    <div *ngIf="checkedFields.expectedDate?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.expectedDate?.labelName }} <span *ngIf="checkedFields.expectedDate?.isRequired" class="required-sign">*</span></label>
                        <p-calendar formControlName="expectedDate" styleClass="w-100" 
                            [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
                            [minDate]="minDateValue" dateFormat="mm/dd/yy" yearRange="1900:2100" [showTime]="false"
                            [readonlyInput]="true" [showButtonBar]="true"
                            appendTo="body" [ngClass]="{ 'ng-invalid':  detailsFormErrors?.expectedDate}">
                        </p-calendar>

                        <div *ngIf="detailsFormErrors?.expectedDate" class="p-invalid">
                            <small>{{ detailsFormErrors?.expectedDate }}</small>
                        </div>
                    </div>

                    <div *ngIf="checkedFields.currentStage?.enabledInForm" class="p-col-12"
                        [ngClass]="{'p-md-6': !checkedFields.repConfidence?.enabledInForm, 'p-md-4': checkedFields.repConfidence?.enabledInForm}">
                        <label>{{ checkedFields.currentStage?.labelName }} <span *ngIf="checkedFields.currentStage?.isRequired"
                                class="required-sign">*</span></label>
                        <p-dropdown formControlName="opportunityStageId" [options]="allStagesDropdown"
                            (onChange)="selectedOpportunityStage($event.value)" optionLabel="name" optionValue="id" appendTo="body"
                            [placeholder]="'Select ' + checkedFields.currentStage?.labelName">
                            <ng-template let-stage pTemplate="item">
                                <div>{{ stage.name }} ({{ stage.probability }}%)</div>
                            </ng-template>
                        </p-dropdown>

                        <div *ngIf="detailsFormErrors?.currentStage" class="p-invalid">
                            <small>{{ detailsFormErrors?.currentStage }}</small>
                        </div>
                    </div>

                    <div *ngIf="checkedFields.repConfidence?.enabledInForm" class="p-col-12 p-md-6"
                        [ngClass]="{'p-md-6': !checkedFields.currentStage?.enabledInForm, 'p-md-2': checkedFields.currentStage?.enabledInForm}">
                        <label>{{ checkedFields.repConfidence?.labelName }} <span *ngIf="checkedFields.repConfidence?.isRequired"
                                class="required-sign">*</span></label>
                        <p-inputNumber formControlName="repConfidence" :min="0" :max="99" maxlength="3" inputId="percent" suffix="%"
                            placeholder="%" styleClass="w-100" class="w-100">
                        </p-inputNumber>

                        <div *ngIf="detailsFormErrors?.repConfidence" class="p-invalid">
                            <small>{{ detailsFormErrors?.repConfidence }}</small>
                        </div>
                    </div>

                    <div *ngIf="checkedFields.totalAmount?.enabledInForm" class="p-col-12 p-md-6">
                        <label>{{ checkedFields.totalAmount?.labelName }} <span *ngIf="checkedFields.totalAmount?.isRequired" class="required-sign">*</span></label>
                        <p-inputNumber formControlName="totalAmount" mode="decimal" min="0" [minFractionDigits]="0" 
                        [maxFractionDigits]="maximumFractionDigits" styleClass="w-100" class="w-100"></p-inputNumber>

                        <div *ngIf="detailsFormErrors?.totalAmount" class="p-invalid">
                            <small>{{ detailsFormErrors?.totalAmount }}</small>
                        </div>
                    </div>

                    <div class="p-col-12 p-lg-6" *ngIf="stageCommentEnable && crudType != 'add'">
                        <label class="p-mb-2">
                             Comment
                        </label>
                        <textarea pInputTextarea name="description" formControlName="comment" rows="2" class="w-100"></textarea>
                    </div>

                    <!-- <div class="p-col-12 p-lg-6">
                        <label>Currency</label>
                        <p-dropdown [options]="currencies" placeholder="Select Currency..." optionLabel="name" 
                        appendTo="body" dataKey="id" ></p-dropdown>
                    </div> -->
                    <div class="p-col-12 p-lg-12 p-d-flex p-mt-5" *ngIf="accountDetails && (baseCurrency?.currencyId !== accountDetails?.currencyId)" style="justify-content: flex-end;">
                        <div class="p-mt-1">
                            1 {{baseCurrency?.code}} = {{currencyExchangeRate}} {{accountDetails?.currencyUnit?.code}}
                        </div>
                        <span class="btnBars" (click)="editCurrency.toggle($event);">
                            <i class="pi pi-pencil"></i>
                        </span>
                    </div>
                    <p-overlayPanel #editCurrency [showCloseIcon]="true" styleClass="no-padding custom-overlay-header" [style]="{width: '300px'}">
                        <div class="panel-header">
                            <h5 class="p-mb-0">Edit Exchange Rate</h5>
                        </div>
                        @if(accountDetails){
                            <app-edit-exchangerate [vendorCurrencyExchangeRate]="currencyExchangeRate" [vendorDetails]="accountDetails" [orgCurrency]="orgCurrency"
                                (closeDialog)="closeCurrencyDialog($event)">
                            </app-edit-exchangerate>
                        }
                    </p-overlayPanel>

                    <!-- Product Selection -->
                    <div class="p-col-12" formArrayName="opportunityProducts">
                        <div style="padding-top: 10px;"
                        *ngIf="checkedFields.itemNo?.enabledInForm
                        || checkedFields.productDescription?.enabledInForm
                        || checkedFields.uom?.enabledInForm
                        || checkedFields.unit?.enabledInForm
                        || checkedFields.price?.enabledInForm
                        || checkedFields.itemTotal?.enabledInForm">

                            <!-- <div class="p-field p-grid">
                                <div class="p-col-2" *ngIf="checkedFields.itemNo?.enabledInForm">
                                    <label>{{ checkedFields.itemNo?.labelName }}</label>
                                </div>
                                <div class="p-col-2" *ngIf="checkedFields.productDescription?.enabledInForm">
                                    <label>{{ checkedFields.productDescription?.labelName||'Product Description' }}</label>
                                </div>
                                <div class="p-col-1" *ngIf="checkedFields.unit?.enabledInForm">
                                    <label>{{ checkedFields.unit?.labelName }}</label>
                                </div>
                                <div class="p-col-2" *ngIf="checkedFields.uom?.enabledInForm">
                                    <label>{{ checkedFields.uom?.labelName }}</label>
                                </div>
                                <div class="p-col-2" *ngIf="checkedFields.price?.enabledInForm">
                                    <label>{{ checkedFields.price?.labelName }}</label>
                                </div>
                                <div class="p-col-2" *ngIf="checkedFields.itemTotal?.enabledInForm">
                                    <label>{{ checkedFields.itemTotal?.labelName }}</label>
                                </div>
                                <div class="p-col-1">
                                    <div pButton (click)="openAddProductDialog()" style="width: 50%;margin-left: auto;" [ngStyle]="{'margin-top': '0%'}" class="p-button-text p-button-rounded" label="" icon="pi pi-plus"></div>
                                </div>
                            </div> -->

                            <!-- <div class="p-field p-grid" *ngFor="let item of getAddedProducts(opportunityForm); let itemIndex=index" [formGroupName]="itemIndex">
                                <div class="p-col-2" *ngIf="checkedFields.itemTotal?.enabledInForm">
                                    <input pInputText type="text" formControlName="itemNo" readonly>
                                </div>
                                <div class="p-col-2" *ngIf="checkedFields.productDescription?.enabledInForm">
                                    <input pInputText type="text" formControlName="description" readonly>
                                </div>
                                <div class="p-col-1" *ngIf="checkedFields.unit?.enabledInForm">
                                    <p-inputNumber formControlName="qty" min="0" mode="decimal" [disabled]="!item.value.productId || !checkedFields.unit?.enabledInForm"
                                        onkeydown="if(event.key==='.'){event.preventDefault();}"
                                        onpaste="let pasteDataAdd = event.clipboardData.getData('text'); if(pasteDataAdd){pasteDataAdd.replace(/[^0-9]*/g,'');}">
                                    </p-inputNumber>
                                </div>
                                <div class="p-col-2" *ngIf="checkedFields.uom?.enabledInForm">
                                    <p-dropdown formControlName="uomId"
                                        [options]="item.value.uomList" optionLabel="uomDetail.name" optionValue="unitOfMeasureId"
                                        placeholder="Select Unit of Measure"
                                        [disabled]="!item.value.productId || !checkedFields.uom?.enabledInForm">
                                    </p-dropdown>
                                </div>
                                <div class="p-col-2" *ngIf="checkedFields.price?.enabledInForm">
                                    <p-inputNumber formControlName="price"
                                        mode="decimal" min="0" [minFractionDigits]="0" [maxFractionDigits]="maximumFractionDigits"
                                        [disabled]="!item.value.productId || !checkedFields.price?.enabledInForm">
                                    </p-inputNumber>
                                </div>
                                <div class="p-col-2" *ngIf="checkedFields.itemTotal?.enabledInForm">
                                    <p-inputNumber formControlName="totalAmount"
                                        mode="decimal" min="0" [minFractionDigits]="0" [maxFractionDigits]="maximumFractionDigits"
                                        [disabled]="true">
                                    </p-inputNumber>
                                </div>
                                <div class="p-col-1">
                                    <div pButton (click)="removeProduct(itemIndex)" [ngStyle]="{'margin-top': '0%' }" style="width: 50%;margin-left: auto;" class="p-button-text p-button-rounded" label="" icon="pi pi-minus">
                                    </div>
                                </div>
                            </div> -->

                            
                            <!-- Common product add -->
                            <app-common-product-add-form 
                                [checkedFields]="checkedFields" [pricebookConfig]="pricebookConfig" [accountDetails]="accountDetails" [recalculate]="recalculateWrapper"
                                [moduleName]="moduleName" [loggedUserDetails]="loggedUserDetails" [savedProductOrderModel]="savedProductOrderModel"
                                [baseCurrency]="baseCurrency" [currencyExchangeRate]="currencyExchangeRate" [previousCurrencyExchangeRate]="previousCurrencyExchangeRate" [currencyUnit]="accountDetails?.currencyUnit"
                                (productEventEmitter)="onChangeProducts($event)">
                            </app-common-product-add-form>
                        </div>
                    </div>



                    <!-- Product Selection End -->


                    <div *ngIf="checkedFields.description?.enabledInForm" class="p-col-12">
                        <label>{{ checkedFields.description?.labelName }} <span *ngIf="checkedFields.description?.isRequired" class="required-sign">*</span></label>
                        <textarea formControlName="description" pInputTextarea rows="3" class="w-100"></textarea>

                        <div *ngIf="detailsFormErrors?.description" class="p-invalid">
                            <small>{{ detailsFormErrors?.description }}</small>
                        </div>
                    </div>

                     <!-- Custom Attributes Fields -->
                     <div class="p-col-12" formArrayName="customAttributeValues">
                        <div class="p-grid">
                            <div class="p-col-12 p-md-6" *ngFor="let customField of getAddedCustomAttributes(opportunityForm); let itemIndex=index" [formGroupName]="itemIndex">

                                <label>{{ customField.value.labelName }} <span *ngIf="customField.value.isRequired" class="required-sign">*</span></label>

                                <ng-container [ngSwitch]="customField.value.formControlId">
                                    <!-- Input -->
                                    <ng-container *ngSwitchCase="formControlListIds.InputBox">
                                        <input pInputText type="text" formControlName="value"  
                                        [ngClass]="{'p-disabled': customField.value?.readOnly}" [readonly]="customField.value?.readOnly"
                                        [placeholder]="'Enter value'"/>
                                    </ng-container>

                                    <!-- Number -->
                                    <ng-container *ngSwitchCase="formControlListIds.Number">
                                        <p-inputNumber class="w-100" styleClass="w-100" 
                                            formControlName="value" [placeholder]="'Enter value'"
                                            [ngClass]="{'p-disabled': customField.value?.readOnly}" [readonly]="customField.value?.readOnly"  
                                            (keypress)="isNumberKey($event)">
                                        </p-inputNumber>
                                    </ng-container>

                                    <!-- Decimal -->
                                    <ng-container *ngSwitchCase="formControlListIds.Decimal">
                                        <p-inputNumber class="w-100" styleClass="w-100" 
                                            formControlName="value" [placeholder]="'Enter value'"
                                            [ngClass]="{'p-disabled': customField.value?.readOnly}" [readonly]="customField.value?.readOnly"
                                            [minFractionDigits]="0" [maxFractionDigits]="(customField.value?.maxLengthAfterDecimal||6)"
                                            (keypress)="isNumberKey($event)">
                                        </p-inputNumber>
                                    </ng-container>

                                    <!-- Dropdown -->
                                    <ng-container *ngSwitchCase="formControlListIds.DropDownList">
                                        <p-dropdown
                                            [options]="customField.value.pickListValues"
                                            [placeholder]="'Select ' + customField.value.labelName"
                                            [ngClass]="{'p-disabled': customField.value?.readOnly}" [readonly]="customField.value?.readOnly"
                                            formControlName="values" optionLabel="name" appendTo="body">
                                        </p-dropdown>
                                    </ng-container>

                                    <!-- Multiple Dropdown -->
                                    <ng-container *ngSwitchCase="formControlListIds.MultipleDropDownList">
                                        <p-multiSelect
                                            [options]="customField.value.pickListValues"
                                            [placeholder]="'Select ' + customField.value.labelName"
                                            [ngClass]="{'p-disabled': customField.value?.readOnly}" [readonly]="customField.value?.readOnly"
                                            formControlName="multipleValues" optionLabel="name" appendTo="body">
                                        </p-multiSelect>
                                    </ng-container>

                                    <!-- CheckBox -->
                                    <ng-container *ngSwitchCase="formControlListIds.CheckBox">
                                        <ng-container *ngFor="let pickName of customField.value.pickListValues">
                                            <p-checkbox [value]="pickName" [formControl]="customField.get('multipleCheckBox')"
                                            [ngClass]="{'p-disabled': customField.value?.readOnly}" [readonly]="customField.value?.readOnly"
                                            ></p-checkbox>
                                            {{ pickName }}
                                        </ng-container>
                                    </ng-container>

                                    <!-- File Upload -->
                                    <ng-container *ngSwitchCase="formControlListIds.FileUpload">
                                        <p-fileUpload customUpload="true" class="fupload" previewWidth="100" chooseLabel="Choose"
                                            [showUploadButton]="false" [multiple]="true" [showCancelButton]="false" (onSelect)="onCustomUpload($event, customField, 'any')"
                                            [ngClass]="{'p-disabled': customField.value?.readOnly}" [readonly]="customField.value?.readOnly"
                                            >
                                            <ng-template pTemplate="file"></ng-template>
                                            <ng-template pTemplate="content">
                                                <ng-container *ngFor="let file of (customField.value.customeAttachement||[]); let i = index;">
                                                        <div class="p-fileupload-row" *ngIf="file">
                                                            <button pButton icon="fa fa-download" (click)="downloadFile(file.name, file.content)"
                                                                class="p-button-link p-px-0 p-py-0">
                                                            </button>
                                                            <ng-container *ngIf="file.name.length > 15 else splitFileName">
                                                                <div [pTooltip]="file.name">
                                                                    {{ file.name.substring(0, 14) }} ...
                                                                </div>
                                                            </ng-container>
                                                            <ng-template #splitFileName>
                                                                <div> {{ file.name }} </div>
                                                            </ng-template>
                                                            <div>
                                                                {{ file.sizeInBytes | fileSize }}
                                                            </div>
                                                            <div>
                                                                <button icon="pi pi-times" pButton (click)="removeCustomFile(i, customField)" type="button"
                                                                    icon="pi pi-times">
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                            </ng-template>
                                        </p-fileUpload>
                                    </ng-container>

                                    <!-- Picture -->
                                    <ng-container *ngSwitchCase="formControlListIds.Picture">
                                        <p-fileUpload customUpload="true" class="fupload" previewWidth="100" chooseLabel="Choose"
                                            accept="image/*" [multiple]="true" [showUploadButton]="false" [showCancelButton]="false"
                                            (onSelect)="onCustomUpload($event, customField, 'image')" [ngClass]="{'p-disabled': customField.value?.readOnly}" 
                                            [readonly]="customField.value?.readOnly">
                                            <ng-template pTemplate="file"></ng-template>
                                            <ng-template pTemplate="content">
                                                <ng-container *ngFor="let picture of (customField.value.customeAttachement||[]); let i = index;">
                                                    <div class="p-fileupload-row p-mb-2">
                                                        <button pButton icon="fa fa-download" (click)="downloadFile(picture.name, picture.content)"
                                                            class="p-button-link p-px-0 p-py-0">
                                                        </button>
                                                        <ng-container *ngIf="picture.content && picture.content.startsWith('data') else localImage">
                                                            <img src="{{ picture.content }}" width="100" alt="card" />
                                                        </ng-container>
                                                        <ng-template #localImage>
                                                            <img [src]="picture.location" width="100" alt="card" />
                                                        </ng-template>
                                                        <ng-container *ngIf="picture.name.length > 15 else splitImageName">
                                                            <div [pTooltip]="picture.name">
                                                                {{ picture.name.substring(0, 14) }}...
                                                            </div>
                                                        </ng-container>
                                                        <ng-template #splitImageName>
                                                            <div> {{ picture.name }} </div>
                                                        </ng-template>
                                                        <div>
                                                            {{ picture.sizeInBytes | fileSize }}
                                                        </div>
                                                        <div>
                                                            <button icon="pi pi-times" pButton (click)="removeCustomFile(i, customField)" type="button"
                                                                icon="pi pi-times">
                                                            </button>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </ng-template>
                                        </p-fileUpload>
                                    </ng-container>

                                    <!-- Radio Button -->
                                    <ng-container *ngSwitchCase="formControlListIds.RadioButton">
                                        <ng-container *ngFor="let pickName of customField.value.pickListValues">
                                            <p-radioButton [value]="pickName" formControlName="value" 
                                            [ngClass]="{'p-disabled': customField.value?.readOnly}" [readonly]="customField.value?.readOnly">
                                            </p-radioButton>&nbsp; {{ pickName }}
                                        </ng-container>
                                    </ng-container>

                                    <!-- Date Picker -->
                                    <ng-container *ngSwitchCase="formControlListIds.DatePicker">
                                        <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy" appendTo="body"
                                            dateFormat="mm/dd/yy" yearRange="1900:2100" [showTime]="false" formControlName="value"
                                            [ngClass]="{'p-disabled': customField.value?.readOnly}" [readonly]="customField.value?.readOnly"
                                            styleClass="w-100">
                                        </p-calendar>
                                    </ng-container>

                                    <!-- Rating -->
                                    <ng-container *ngSwitchCase="formControlListIds.Rating">
                                        <p-rating [cancel]="false" formControlName="ratingId" 
                                        [ngClass]="{'p-disabled': customField.value?.readOnly}" [readonly]="customField.value?.readOnly"></p-rating>
                                    </ng-container>

                                    <!-- Toggle Button -->
                                    <ng-container *ngSwitchCase="formControlListIds.ToggleButton">
                                        <p-inputSwitch formControlName="toggle" class="vertical-middle" 
                                        [ngClass]="{'p-disabled': customField.value?.readOnly}" [readonly]="customField.value?.readOnly"></p-inputSwitch>
                                    </ng-container>
                                </ng-container>

                                <div *ngIf="isRequiredTouched(customField)" class="p-invalid">
                                    <small>{{ customField.value.labelName }} is required</small>
                                </div>
                            </div>
                        </div>
                     </div>
                     <!-- Custom Attributes Fields End -->

                </div>
            </div>

        </form>
    </ng-container>
    <ng-container *ngIf="opportunityViewDetails && checkedFields && crudType=='view'">

        <div class="header">
            <h5>
                {{ templateSections?.[0]?.name||'Opportunity Information'}}
                <p-inputSwitch [(ngModel)]="opportunityViewDetails.isActive" class="header-switch" [disabled]="crudType=='view'"></p-inputSwitch>
            </h5>
        </div>

        <div class="card">
            <div class="p-grid p-pt-2">
                <ng-container *ngFor="let checkField of checkedFieldList">
                    <div *ngIf="checkField && checkField?.enabledInForm && opportunityViewDetails[checkField.formFieldname]"  class="p-col-12 p-md-6">
                        <div class="p-grid">
                            <div class="p-col-4 p-pt-0 p-pb-0">
                                <p>
                                    <strong>{{checkField.labelName}}</strong> <span *ngIf="checkField?.isRequired" class="required-sign p-pl-1">*</span>
                                </p>
                            </div>
                            <div class="p-col-8 p-pt-0 p-pb-0">
                                <p>{{ opportunityViewDetails[checkField.formFieldname] }}</p>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngFor="let checkField of  this.templateSections[0]?.customFields">
                    <div *ngIf="checkField && checkField?.enabledInForm && opportunityViewDetails.customAttributeValues[checkField.customAttributeId]"  class="p-col-12 p-md-6">
                        <div class="p-grid">
                            <div class="p-col-4 p-pt-0 p-pb-0">
                                <p>
                                    <strong>{{checkField.labelName}}</strong> <span *ngIf="checkField?.isRequired" class="required-sign p-pl-1">*</span>
                                </p>
                            </div>
                            <div class="p-col-8 p-pt-0 p-pb-0">
                                <p>{{ opportunityViewDetails.customAttributeValues[checkField.customAttributeId] }}</p>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <!-- Added Product Details -->
                <p-table [value]="opportunityViewDetails.opportunityProducts" dataKey="id" class="w-100"
                styleClass="p-datatable-gridlines p-datatable-striped w-100">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width:2rem"></th>
                            <th *ngIf="checkedFields.itemNo?.enabledInForm">{{ checkedFields.itemNo?.labelName }}</th>
                            <th *ngIf="checkedFields.productDescription?.enabledInForm">{{ checkedFields.productDescription?.labelName||'Product Description' }}</th>
                            <th *ngIf="checkedFields.unit?.enabledInForm">{{ checkedFields?.unit?.labelName }}</th>
                            <th *ngIf="checkedFields.uom?.enabledInForm">{{ checkedFields?.uom?.labelName }}</th>
                            <th *ngIf="checkedFields.price?.enabledInForm">{{ checkedFields?.price?.labelName }}</th>
                            <th *ngIf="checkedFields.subTotal?.enabledInForm">{{ checkedFields?.subTotal?.labelName }}</th>
                            <th *ngIf="checkedFields.productDiscount?.enabledInForm">{{ checkedFields?.productDiscount?.labelName }}</th>
                            <th *ngIf="checkedFields.tax?.enabledInForm">{{ checkedFields?.tax?.labelName }}</th>
                            <th *ngIf="checkedFields.handlingFeesAmount?.enabledInForm">{{ checkedFields?.handlingFeesAmount?.labelName }}</th>
                            <th *ngIf="checkedFields.itemTotal?.enabledInForm">{{ checkedFields?.itemTotal?.labelName }}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-opp let-i="rowIndex" let-expanded="expanded">
                        <tr>
                            <td class="action">
                                <button type="button" [pRowToggler]="product" pButton pRipple
                                class="p-button-text p-button-rounded p-button-plain" 
                                (click)="isBundleExpanded = !isBundleExpanded"
                                [icon]="isBundleExpanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                                *ngIf="opp.opportunityBundleProducts.length>0"
                                style="width: 1.25rem; height: 1.25rem"></button>
                            </td>
                            <td *ngIf="checkedFields.itemNo?.enabledInForm">{{opp?.itemNo}}</td>
                            <td *ngIf="checkedFields.productDescription?.enabledInForm">{{opp?.description | shorten}}</td>
                            <td *ngIf="checkedFields.unit?.enabledInForm">{{opp?.qty | customNumberFormat: qtyFractionDigits}}</td>
                            <td *ngIf="checkedFields.uom?.enabledInForm">{{opp?.unit?.uomDetail?.name ?? ''}}</td>
                            <td *ngIf="checkedFields.price?.enabledInForm">{{opp?.productTypeId == pTypeId.BundleTypeId ? '' : opp?.price | multicurrency: currencyExchangeRate ?? baseCurrency?.exchangeRate : opportunityDetails?.currencyUnit?.symbol ?? baseCurrency?.symbol : maximumFractionDigits}}</td>
                            <td *ngIf="checkedFields.subTotal?.enabledInForm">{{ opp?.subTotal | multicurrency: currencyExchangeRate ?? baseCurrency?.exchangeRate : opportunityDetails?.currencyUnit?.symbol ?? baseCurrency?.symbol : maximumFractionDigits}}</td>
                            <td *ngIf="checkedFields.productDiscount?.enabledInForm">{{opp?.productTypeId == pTypeId.BundleTypeId ? '' : opp?.discountAmount | multicurrency: currencyExchangeRate ?? baseCurrency?.exchangeRate : opportunityDetails?.currencyUnit?.symbol ?? baseCurrency?.symbol : maximumFractionDigits}}</td>
                            <td *ngIf="checkedFields.tax?.enabledInForm">{{opp?.productTypeId == pTypeId.BundleTypeId ? '' : opp?.taxSumAmount | multicurrency: currencyExchangeRate ?? baseCurrency?.exchangeRate : opportunityDetails?.currencyUnit?.symbol ?? baseCurrency?.symbol : maximumFractionDigits}}</td>
                            <td *ngIf="checkedFields.handlingFeesAmount?.enabledInForm">{{opp?.productTypeId == pTypeId.BundleTypeId ? '' : opp?.additionalAmount | multicurrency: currencyExchangeRate ?? baseCurrency?.exchangeRate : opportunityDetails?.currencyUnit?.symbol ?? baseCurrency?.symbol : maximumFractionDigits}}</td>
                            <td *ngIf="checkedFields.itemTotal?.enabledInForm"> {{ opp?.totalAmount | multicurrency: currencyExchangeRate ?? baseCurrency?.exchangeRate : opportunityDetails?.currencyUnit?.symbol ?? baseCurrency?.symbol : maximumFractionDigits}}</td>
                        </tr>
                        <ng-container *ngIf="opp.opportunityBundleProducts.length>0 && isBundleExpanded">
                            <tr class="bundleRow" *ngFor="let bundle of opp.opportunityBundleProducts">
                                <td></td>
                                <td *ngIf="checkedFields.itemNo?.enabledInForm">{{bundle?.itemNo}}</td>
                                <td *ngIf="checkedFields.productDescription?.enabledInForm">{{bundle?.description | shorten}}</td>
                                <td *ngIf="checkedFields.unit?.enabledInForm">{{bundle?.orderQty | customNumberFormat: qtyFractionDigits}}</td>
                                <td *ngIf="checkedFields.uom?.enabledInForm">{{bundle?.unit?.uomDetail?.name ?? ''}}</td>
                                <td *ngIf="checkedFields.price?.enabledInForm">{{opp?.productTypeId == pTypeId.KitTypeId ? '' : bundle?.price | multicurrency: currencyExchangeRate ?? baseCurrency?.exchangeRate : opportunityDetails?.currencyUnit?.symbol ?? baseCurrency?.symbol : maximumFractionDigits}}</td>
                                <td *ngIf="checkedFields.subTotal?.enabledInForm">{{opp?.productTypeId == pTypeId.KitTypeId ? '' : bundle?.subTotal | multicurrency: currencyExchangeRate ?? baseCurrency?.exchangeRate : opportunityDetails?.currencyUnit?.symbol ?? baseCurrency?.symbol : maximumFractionDigits}}</td>
                                <td *ngIf="checkedFields.productDiscount?.enabledInForm">{{opp?.productTypeId == pTypeId.KitTypeId ? '' : bundle?.discountAmount | multicurrency: currencyExchangeRate ?? baseCurrency?.exchangeRate : opportunityDetails?.currencyUnit?.symbol ?? baseCurrency?.symbol : maximumFractionDigits}}</td>
                                <td *ngIf="checkedFields.tax?.enabledInForm">{{opp?.productTypeId == pTypeId.KitTypeId ? '' : bundle?.totalBundleTaxAmount | multicurrency: currencyExchangeRate ?? baseCurrency?.exchangeRate : opportunityDetails?.currencyUnit?.symbol ?? baseCurrency?.symbol : maximumFractionDigits}}</td>
                                <td *ngIf="checkedFields.handlingFeesAmount?.enabledInForm">{{opp?.productTypeId == pTypeId.KitTypeId ? '' : bundle?.additionalAmount | multicurrency: currencyExchangeRate ?? baseCurrency?.exchangeRate : opportunityDetails?.currencyUnit?.symbol ?? baseCurrency?.symbol : maximumFractionDigits}}</td>
                                <td *ngIf="checkedFields.itemTotal?.enabledInForm"> {{opp?.productTypeId == pTypeId.KitTypeId ? '' : bundle?.totalAmount | multicurrency: currencyExchangeRate ?? baseCurrency?.exchangeRate : opportunityDetails?.currencyUnit?.symbol ?? baseCurrency?.symbol : maximumFractionDigits}}</td>
                            </tr>
                        </ng-container>
                    </ng-template>
                    <ng-template pTemplate="footer" let-opp>
                        <!-- Discount Section -->
                        <tr *ngIf="!checkedFields?.productDiscountType?.enabledInForm">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td [attr.colspan]="cols - 3" class="p-text-right">Discount</td>
                            <td>{{opp?.discountAmount | multicurrency: currencyExchangeRate ?? baseCurrency?.exchangeRate : opportunityDetails?.currencyUnit?.symbol ?? baseCurrency?.symbol : maximumFractionDigits}}</td>
                        </tr>
                        <!-- Tax Section -->
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td [attr.colspan]="cols - 3" class="p-text-right">Total Tax</td>
                            <td>{{opportunityDetails?.taxAmount | multicurrency: currencyExchangeRate ?? baseCurrency?.exchangeRate : opportunityDetails?.currencyUnit?.symbol ?? baseCurrency?.symbol : maximumFractionDigits}}</td>
                        </tr>
                        <!-- Handling Fees Section -->
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td [attr.colspan]="cols - 3" class="p-text-right">Handling Fees</td>
                            <td>{{opportunityDetails?.additionalAmount | multicurrency: currencyExchangeRate ?? baseCurrency?.exchangeRate : opportunityDetails?.currencyUnit?.symbol ?? baseCurrency?.symbol : maximumFractionDigits}}</td>
                        </tr>
                        <!-- Additional Discount Section -->
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td [attr.colspan]="cols - 3" class="p-text-right">Additional Discount</td>
                            <td>{{opportunityDetails?.opportunityAddDiscount[0]?.discountAmount  | multicurrency: currencyExchangeRate ?? baseCurrency?.exchangeRate : opportunityDetails?.currencyUnit?.symbol ?? baseCurrency?.symbol : maximumFractionDigits}}</td>
                        </tr>
                        <!-- Shipping Section -->
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td [attr.colspan]="cols - 3" class="p-text-right">Shipping</td>
                            <td>{{opportunityDetails?.shippingChargeAmount | multicurrency: currencyExchangeRate ?? baseCurrency?.exchangeRate : opportunityDetails?.currencyUnit?.symbol ?? baseCurrency?.symbol : maximumFractionDigits}}</td>
                        </tr>
                        <!-- Total Section -->
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td [attr.colspan]="cols - 3" class="p-text-right">Total</td>
                            <td>{{ opportunityViewDetails?.opportunityProducts?.length > 0 
                                ? (opportunityDetails?.netAmount | multicurrency: currencyExchangeRate ?? baseCurrency?.exchangeRate : opportunityDetails?.currencyUnit?.symbol ?? baseCurrency?.symbol : maximumFractionDigits) 
                                : ('0' | customNumberFormat:maximumFractionDigits | currencySymbol)}}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                <!-- Added Product Details End -->
            </div>
        </div>


        <app-shared-activities-timeline
            [objectId]="opportunityViewDetails?.id"
            [selectedObject]="opportunityViewDetails"
            objectType="Opportunity"
            [hideRigthArrow]="true"
            [showActivityLoader]="false"
            [isViewMode]="opportunityViewDetails.statusId != 1">
        </app-shared-activities-timeline>


    </ng-container>

    <ng-container *ngIf="detailsLoadingFailed">
        <div class="card view-details-error-message">
            <span class="pi pi-exclamation-circle" style="font-size: 25px;"></span>
            <p>{{ detailsErrorMessage }}</p>
        </div>
    </ng-container>

    <p-footer>
        <button type="button" pButton (click)="closeOpportunityDialog()" label="Cancel" class="p-button-secondary"></button>
        <button *ngIf="crudType!='view'" type="button" pButton class="p-button-label" label="Save & View" (click)="saveOpportunity('view')" [disabled]="formSubmitted"></button>
        <button *ngIf="crudType!='view'" type="button" pButton class="p-button-label" label="Save" (click)="saveOpportunity()"  [disabled]="formSubmitted"></button>
    </p-footer>
</p-dialog>


<app-product-selection-modal *ngIf="opportunityForm" [displayProductSelectionModal]="isDisplayProductDialog" appendTo="body"
    [moduleName]="moduleName" [headerText]="headerText" [pricebookConfig]="pricebookConfig"
    [selectedProductsList]="(addedProducts||[])"
    [isVisibleLocation]="isVisibleLocation" [selectedLocationId]="selectedLocationId"
    [selectedAccountId]="opportunityForm.value.accountId?.id" (onCancelClicked)="cancelProductAdd($event)"
    (onProductAddComplete)="onProductAddComplete($event)" (onLocationSelect)="onLocationSelect($event)">
</app-product-selection-modal>

<app-lion-active-inactive-modal
    *ngIf="displayActiveInactiveModal && opportunityDetails"
    [displayActiveInactiveModal]="displayActiveInactiveModal"
    [activeInactiveFormType]="'Add'"
    [id]="opportunityDetails.id"
    [statusId]="opportunityStatusId"
    [moduleName]="moduleName"
    (cancelActiveInactiveModal)="cancelActiveInactiveModal()"
    (saveActiveInactiveModal)="saveActiveInactiveModal()">
</app-lion-active-inactive-modal>

<app-shared-manual-modal [displayPopup]="displayManualPopup"
    [colsList]="manualRuleColumnSetttings" [singleSelection]="true" [selectedObjectType]="selectedModule"
    [selectedTemplateType]="selectedTemplate" [selectedAccount]="selectedRecordList"
    (saveAssignDataclicked)="saveParentAccount($event)" (cancelClicked)="manualpopupCancelClicked()"
    (saveSettingClicked)="columnSettingSaved($event)">
</app-shared-manual-modal>
